import ErrorBoundary from "@/ErrorBoundary";

export default function StreamerModeAlert({ socket, streamerMode }: { socket: any, streamerMode: any }) {
    return (
        <>
            <ErrorBoundary>
                {(socket && streamerMode?.enabled) && (
                    <div className="w-screen bg-gradient-to-r from-pink-600 to-purple-500 sm:-ml-4 sm:-mr-4">
                        <div className="flex items-center justify-center font-medium py-1">
                            <p className="text-white text-sm">
                                Streamer mode is enabled, your privacy is protected.
                            </p>
                            <button
                                onClick={() => {
                                    localStorage.setItem(
                                        "streamerMode",
                                        JSON.stringify({
                                            enabled: false,
                                            details: JSON.parse(localStorage.getItem("streamerMode")!)?.details,
                                        })
                                    );
                                    window.dispatchEvent(new Event('storage'))
                                }}
                                className="text-white font-semibold border px-4  rounded-lg text-sm ml-4"
                            >
                                Disable
                            </button>
                        </div>
                    </div>
                )}
            </ErrorBoundary>
        </>
    )
}
